import { Component, Input } from '@angular/core';
import { CvParameter, Parameter } from '../../../modules/lipidcompass-backend-client';
import { NoWrapPipe } from '../_pipes/nowrap.pipe';
import { TitleCasePipe } from "../_pipes/titlecase.pipe";


@Component({
    selector: 'app-olslink',
    templateUrl: './olslink.component.html',
    styleUrls: ['./olslink.component.css'],
    standalone: true,
    imports: [
    NoWrapPipe,
    TitleCasePipe
]
})
export class OlslinkComponent {

  @Input() cvParam: CvParameter | undefined;

  @Input() param: Parameter | undefined;

  @Input() displayValue: Boolean = true;

  @Input() linkOnly: Boolean = false;

  @Input() olsBaseUrl: String = 'https://www.ebi.ac.uk/ols4/search?q=';

}
